module.exports = __webpack_public_path__ + "img/fddb3b9fb88682842c4406e38def1860.png";